module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_WarningTriangle_16"],"path":[{"$":{"d":"M8,0,0,15H16ZM9,13H7V11H9ZM7,9V5H9V9Z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_WarningTriangle_16.svg
// module id = y2i4
// module chunks = 1